export default __webpack_public_path__ + "static/media/documentsLoading.26146444.svg";